<template>
  <v-card class="elevation-0">
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>

      <v-text-field
        v-on:keyup.enter="searchOnEnter"
        v-on:blur="searchOnEnter"
        append-icon="mdi-magnify"
        hint="Kode, Deskripsi (press ENTER to search)"
        label="Search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model="selectedItems"
      :single-select="!multiSelect"
      :show-select="multiSelect"
      :headers="headers"
      :items="fDinCarouselsFiltered"
      :page.sync="currentPage"
      :items-per-page="pageSize"
      hide-default-footer
      class="elevation-0"
      @page-count="totalTablePages = totalPaginationPages"
    >
      <template v-slot:top>
        <v-row align="center" class="ml-4 mr-4">
          <v-switch
            v-model="multiSelect"
            :label="multiSelect ? 'Multi Select' : 'Single Select'"
            x-small
            class="pa-3"
          ></v-switch>
          <v-btn
            fab
            dark
            color="red accent-4"
            x-small
            :disabled="!multiSelect"
            class="mr-2"
            @click="deleteDialogMultiShow"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-menu offset-y style="align-items: start">
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab dark x-small color="blue" v-bind="attrs" v-on="on">
                <v-icon>mdi-view-grid</v-icon>
              </v-btn>
            </template>
            <v-list color="grey lighten-4" class="mr">
              <v-list-item>
                <v-btn
                  plain
                  elevation="0"
                  color="gray darken-1"
                  small
                  @click="importDialogShow"
                >
                  <v-icon color="green">mdi-upload</v-icon>
                  Import from Template
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn
                  plain
                  elevation="0"
                  color="gray darken-1"
                  small
                  @click="importExtDialogShow"
                >
                  <v-icon color="red">mdi-upload</v-icon>
                  Import from Template Extended
                </v-btn>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-btn
                  class="mx-1"
                  plain
                  elevation="0"
                  color="gray darken-1"
                  small
                  @click="translateDialogShow"
                >
                  <v-icon color="red">mdi-translate</v-icon>
                  Translate to English
                </v-btn>
              </v-list-item>
              <v-divider></v-divider>

            </v-list>
          </v-menu>

          <v-btn
            fab
            dark
            color="green"
            x-small
            @click="showDialogNew"
            :disabled="multiSelect"
            class="ml-1"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </template>

      <template v-slot:[`item.statusActive`]="{ item }">
        <v-chip :color="getColorStatusActive(item.statusActive)" dark small>
          {{ item.statusActive === true ? "Aktif" : "-" }}
        </v-chip>
      </template>

      <template v-slot:[`item.number`]="{ index }">
        {{ index + (currentPage - 1) * pageSize + 1 }}
      </template>

      <template v-slot:[`item.avatar`]="{ item }">
        <v-img
          :lazy-src="lookupImageUrlLazy(item)"
          :src="lookupImageUrl(item)"
          alt="avatar"
          width="200px"
          height="100px"
          class="ma-2 rounded"
        >
        </v-img>
      </template>

      <template v-slot:[`item.description`]="{ item }">
        <div class="subtitle-1" v-if="lang === 'id'">
          {{ item.description }}
        </div>
        <div class="subtitle-1" v-if="lang === 'en'">
          {{ item.descriptionEn }}
        </div>
        <div class="subtitle-2 font-weight-light" v-if="item.kode1">
          *{{ item.kode1 }}
        </div>
      </template>

      <template v-slot:[`item.fdinCarouselTypeBean`]="{ item }">
        <div class="fill-height mt-1">
          <div class="text-caption small" v-if="lang === 'id'">
            {{ lookupFDinCarouselType(item.fdinCarouselTypeBean).description }}
          </div>
          <div class="text-caption small" v-if="lang === 'en'">
            {{ lookupFDinCarouselType(item.fdinCarouselTypeBean).descriptionEn }}
          </div>
          <div>
            {{ item.tahun }}
            <span v-if="item.showToMap"
              ><v-icon small color="blue">mdi-map</v-icon></span
            >
          </div>
        </div>
      </template>

      <template v-slot:[`item.fareaBean`]="{ item }">
        <div class="fill-height mt-1">
          <div class="text-caption small" v-if="lang === 'id'">
            {{ lookupFArea(item.fareaBean).description }}
          </div>
          <div class="text-caption small" v-if="lang === 'en'">
            {{ lookupFArea(item.fareaBean).descriptionEn }}
          </div>
        </div>
      </template>

      <template v-slot:[`item.fdivisionBean`]="{ item }">
        <div class="fill-height">
          <div class="text-caption small">
            {{ lookupFDivision(item.fdivisionBean).description }}
          </div>
          <div>
            <v-chip
              :color="getColorStatusActive(item.statusActive)"
              dark
              x-small
            >
              {{ item.statusActive === true ? "Aktif" : "-" }}
            </v-chip>
          </div>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="caption">
          {{ lookupFDivision(item.fdivisionBean).description }}
        </div>
        <div>
          <v-btn @click="showDialogEdit(item)" icon :disabled="multiSelect">
            <v-icon small color="warning"> mdi-pencil </v-icon>
          </v-btn>

          <v-btn @click="deleteDialogShow(item)" icon :disabled="multiSelect">
            <v-icon small color="red accent-4"> mdi-delete </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-container>
      <v-row justify="end" align="center">
        <v-col cols="4" md="2" sm="2">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per page"
          ></v-select>
        </v-col>
        <v-col cols="10" md="9" sm="8" align="right">
          <v-pagination
            v-model="currentPage"
            :length="totalPaginationPages"
            total-visible="8"
            circle
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <DeleteConfirmDialog
      ref="refDeleteConfirmDialog"
      @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
      @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
    ></DeleteConfirmDialog>
    <ConfirmDialog
      ref="refConfirmDialog"
      @eventFromOkeConfirmDialog="confirmDialogOke"
    ></ConfirmDialog>
    <FDinCarouselDialog
      :formMode.sync="formMode"
      :itemsFDivision="itemsFDivision"
      :itemsFDinCarouselType="itemsFDinCarouselType"
      ref="refFormDialog"
      @eventFromFormDialogNew="saveDataNew"
      @eventFromFormDialogEdit="saveDataEdit"
    ></FDinCarouselDialog>

    <v-dialog width="100px" v-model="dialogLoading">
      <v-card class="px-4 py-7">
        <v-row justify="center">
          <v-col cols="12" align="center">
            <v-progress-circular
              :size="40"
              :width="5"
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackBarMesage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import FDinCarouselService from "../../../services/apiservices/f-din-carousel-service";
import FDivisionService from "../../../services/apiservices/f-division-service";

import DeleteConfirmDialog from "../../utils/DeleteConfirmDialog";

import FDinCarouselDialog from "./FDinCarouselDialog.vue";
import FormMode from "../../../models/form-mode";
import FDinCarousel from "../../../models/f-din-carousel";
import FileService from "../../../services/apiservices/file-service";
import FDinCarouselFilter from "@/models/payload/f-din-carousel-filter";
import ConfirmDialog from "@/components/utils/ConfirmDialog.vue";
import LangTranslatorService from "@/services/apiservices/lang-translator-service";

export default {
  components: {
    FDinCarouselDialog,
    DeleteConfirmDialog,
    ConfirmDialog,
  },
  data() {
    return {
      title: "DINAMIC CAROUSEL",
      snackbar: false,
      snackBarMesage: "",

      dialogLoading: false,
      loading: false,

      multiSelect: false,
      selectedItems: [],

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 10,
      pageSizes: [10, 25, 50, 150, 500, 1500],

      showFilter: false,
      filterFdivisions: [],
      filterFdinCarouselType: [],
      filterFareaBean: [],

      search: "",
      headers: [
        {
          text: "No",
          value: "number",
          width: "8%",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "avatar",
        },
        { text: "Judul", value: "description", width: "50%" },
        { text: "Jenis", value: "fdinCarouselTypeBean" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      formMode: "",
      itemSelectedIndex: -1,
      itemSelected: "",
      fDinCarousels: [new FDinCarousel(0, "", "")],
      itemsFDivision: [{ id: 0, kode1: "", description: "" }],
      itemsFDinCarouselType: [
        {id:1, description:"Home", descriptionEn:"Home"},
        {id:2, description:"Umkm Bermitra", descriptionEn:"Umkm Bermitra"},
        // {id:3, description:"Properti Perumahan", descriptionEn:"Properti Perumahan"},
      ],
      itemsFArea: [],
    };
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (value) this.fetchFDinCarousel();
      },
    },
    pageSize: {
      handler: function (value) {
        const refreshData = this.currentPage === 1;
        this.currentPage = 1;
        if (refreshData) {
          console.log("Change PageSize " + value);
          this.fetchFDinCarousel();
        }
      },
    },
    lang: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          // this.fetchFSectorType()
        }
      },
    },
  },
  computed: {
    lang: {
      get() {
        return this.$store.state.langModule.lang;
      },
      set(val) {
        this.$store.dispatch("langModule/setLang", val);
      },
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    fDinCarouselsFiltered() {
      return this.fDinCarousels;
    },
  },
  methods: {
    showFilterDialog() {
      this.showFilter = !this.showFilter;
    },

    runExtendedFilter() {
      const extendedFilter = new FDinCarouselFilter();

      if (this.filterFdivisions.length > 0) {
        extendedFilter.fdivisionIds = this.filterFdivisions;
      } else {
        extendedFilter.fdivisionIds = this.filterFdivisions.map(
          (item) => item.id
        );
      }

      if (this.filterFdinCarouselType.length > 0) {
        extendedFilter.fdinCarouselTypeIds = this.filterFdinCarouselType;
      } else {
        extendedFilter.fdinCarouselTypeIds = this.itemsFDinCarouselType.map(
          (item) => item.id
        );
      }
      extendedFilter.fareaIds = this.filterFareaBean;
      if (extendedFilter.fareaIds.length === 0) extendedFilter.fareaIds = [];

      extendedFilter.pageNo = this.currentPage;
      extendedFilter.pageSize = this.pageSize;
      extendedFilter.sortBy = "id";
      extendedFilter.order = "DESC";
      extendedFilter.search = this.search;

      extendedFilter.city = "";

      FDinCarouselService.getPostAllFDinCarouselContainingExt(
        extendedFilter
      ).then(
        (response) => {
          const { items, totalPages } = response.data;
          this.fDinCarousels = items;
          this.totalPaginationPages = totalPages;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    searchOnEnter(event) {
      if (this.search !== event.target.value) {
        this.currentPage = 1;
        this.search = event.target.value;
        this.fetchFDinCarousel();
      }
    },

    importDialogShow() {
      this.$refs.refImportDialog.showDialog();
    },
    importExtDialogShow() {
      this.$refs.refImportExtDialog.showDialog();
    },

    importExcelCompleted(value) {
      if (value === "OKE") {
        this.fetchFDinCarousel();
      }
    },
    fetchParent() {
      if (this.currentUser.organizationLevel === "DIV") {
        FDivisionService.getFDivisionById(this.currentUser.fdivisionBean).then(
          (response) => {
            this.itemsFDivision = [response.data];
          },
          (error) => {
            console.log(error.response);
          }
        );
      } else {
        FDivisionService.getAllFDivision().then(
          (response) => {
            this.itemsFDivision = response.data;
          },
          (error) => {
            console.log(error.response);
          }
        );
      }

    },
    fetchFDinCarousel() {
      if (this.showFilter) {
        this.runExtendedFilter();
      } else {
        FDinCarouselService.getAllFDinCarouselContaining(
          this.currentPage,
          this.pageSize,
          "id",
          "DESC",
          this.search
        ).then(
          (response) => {
            const { items, totalPages } = response.data;
            this.fDinCarousels = items;
            this.totalPaginationPages = totalPages;
          },
          (error) => {
            console.log(error.response);
          }
        );
      }
    },
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },
    translateDialogShow() {
      this.$refs.refConfirmDialog.showDialog(
        "Yakin akan Membuat Terjemahan  Data Dalam Daftar? ",
        "(Yang belum mempunyai terjemahan)"
      );
    },
    //DUAL BAHASA
    confirmDialogOke() {
      this.snackBarMesage = "";
      this.dialogLoading = true;
      this.loading = true;
      let itemsFDinCarouselTranslate = [];
      let itemsFDinCarouselSorted = [];
      this.fDinCarousels
        .sort((a, b) => (a.id > b.id ? 1 : -1))
        .forEach((item) => {
          let itemFDinCarouselTranslate = [];
          let emptyValue = "-";
          if (
            item.description !== null &&
            item.description !== undefined &&
            item.description !== "" &&
            item.description !== "-" &&
            (item.descriptionEn === null ||
              item.descriptionEn === undefined ||
              item.descriptionEn === "" ||
              item.descriptionEn === "-")
          ) {
            itemFDinCarouselTranslate.push(item.description);
          } else {
            itemFDinCarouselTranslate.push(emptyValue);
          }
          if (
            item.notes !== null &&
            item.notes !== undefined &&
            item.notes !== "" &&
            item.notesEn !== "-" &&
            (item.notes === null ||
              item.notesEn === undefined ||
              item.notesEn === "" ||
              item.notesEn === "-")
          ) {
            itemFDinCarouselTranslate.push(item.notes);
          } else {
            itemFDinCarouselTranslate.push(emptyValue);
          }
          itemsFDinCarouselTranslate.push(itemFDinCarouselTranslate);
          itemsFDinCarouselSorted.push(item);
        });
      LangTranslatorService.getPostChatGptArrayTranslateIdToEn(
        encodeURIComponent(JSON.stringify(itemsFDinCarouselTranslate))
      ).then(
        (response) => {
          try {
            let itemsFDinCarouselTranslateResponse = decodeURIComponent(
              response.data.translation
            )
              .replaceAll("+", " ")
              .replaceAll("=", " ")
              .trim();
            let itemsFDinCarouselTranslateResponseParsed = JSON.parse(
              itemsFDinCarouselTranslateResponse
            );
            itemsFDinCarouselSorted.forEach((itemFDinCarouselSorted, index) => {
              if (
                (itemFDinCarouselSorted.descriptionEn === null ||
                  itemFDinCarouselSorted.descriptionEn === undefined ||
                  itemFDinCarouselSorted.descriptionEn === "" ||
                  itemFDinCarouselSorted.descriptionEn === "-") &&
                itemsFDinCarouselTranslateResponseParsed[index][0] !== "-"
              ) {
                itemFDinCarouselSorted.descriptionEn =
                  itemsFDinCarouselTranslateResponseParsed[index][0];
              }
              if (
                (itemFDinCarouselSorted.notesEn === null ||
                  itemFDinCarouselSorted.notesEn === undefined ||
                  itemFDinCarouselSorted.notesEn === "" ||
                  itemFDinCarouselSorted.notesEn === "-") &&
                itemsFDinCarouselTranslateResponseParsed[index][1] !== "-"
              ) {
                itemFDinCarouselSorted.notesEn =
                  itemsFDinCarouselTranslateResponseParsed[index][1];
              }
              FDinCarouselService.updateFDinCarousel(itemFDinCarouselSorted).then(
                () => {
                }
              );
            });
            this.dialogLoading = false;
            this.loading = false;
            this.snackbar = true;
            if (this.lang === "id") {
              this.snackBarMesage = "Data berhasil diterjemahkan";
            }
            if (this.lang === "en") {
              this.snackBarMesage = "Data successfully translated";
            }
            this.$refs.refConfirmDialog.setDialogState(false);
          } catch (error) {
            this.dialogLoading = false;
            this.loading = false;
            this.snackbar = true;
            if (this.lang === "id") {
              this.snackBarMesage = "Data yang diterjemahkan melebihi batas";
            }
            if (this.lang === "en") {
              this.snackBarMesage = "The translated data exceeds the limit";
            }
            this.$refs.refConfirmDialog.setDialogState(false);
            console.log(error);
          }
        },
        (error) => {
          console.log(error.data);
        }
      );
    },
    showDialogNew() {
      this.itemSelectedIndex = -1;
      const itemModified = Object.assign({}, "");
      // this.formDialogShow = true
      this.formMode = FormMode.NEW_FORM;
      this.$refs.refFormDialog.showDialog(this.itemSelectedIndex, itemModified);
    },
    saveDataNew(itemFromRest) {
      this.itemSelected = itemFromRest;
      this.closeDialog();
      /**
       * Setiap data baru harus terlihat
       */
      // this.fDinCarousels.push(this.itemSelected)
      // this.fDinCarousels = [itemFromRest].concat(this.fDinCarousels)
      // this.fDinCarousels.unshift(itemFromRest)
      this.fetchFDinCarousel();
    },

    showDialogEdit(item) {
      this.itemSelectedIndex = this.fDinCarouselsFiltered.indexOf(item);
      const itemModified = Object.assign({}, item);
      // this.formDialogShow = true
      this.formMode = FormMode.EDIT_FORM;
      this.$refs.refFormDialog.showDialog(
        this.itemSelectedIndex,
        itemModified,
        this.itemsFDivision
      );
    },
    saveDataEdit(item) {
      this.itemSelected = item;
      if (item.lang !== "id") {
        this.fetchFDinCarousel();
      } else {
        try {
          Object.assign(
            this.fDinCarousels[this.itemSelectedIndex],
            this.itemSelected
          );
        } catch (e) {
          this.fetchFDinCarousel();
          e.toString();
        }
      }
      this.closeDialog();
    },

    deleteDialogShow(item) {
      this.itemSelectedIndex = this.fDinCarouselsFiltered.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      // this.myConfirmDelete = true
      this.$refs.refDeleteConfirmDialog.showDialog(
        this.itemSelectedIndex,
        item.username
      );
    },
    deleteDialogMultiShow() {
      if (this.multiSelect === true) {
        this.$refs.refDeleteConfirmDialog.showDialogMulti(
          this.selectedItems,
          `${this.selectedItems.length} items selected`
        );
      }
    },
    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.fDinCarousels[this.itemSelectedIndex];
      FDinCarouselService.deleteFDinCarousel(deletedItem.id).then(
        () => {
          this.fDinCarousels.splice(this.itemSelectedIndex, 1);
          this.closeDialog();
        },
        (error) => {
          console.log(error);
          this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
          this.snackbar = true;
          this.$refs.refDeleteConfirmDialog.setDialogState(false);
        }
      );
    },
    deleteItemConfirmedMultiSelect(items) {

      if (items.length > -1) {
        let itemIds = [];
        for (let i = 0; i < items.length; i++) {
          itemIds.push(items[i].id);
        }

        FDinCarouselService.deleteAllFDinCarousel(itemIds).then(
          () => {

            if (this.showFilter) {
              this.runExtendedFilter();
            } else {
              this.fetchFDinCarousel();
            }
            this.selectedItems = [];
            this.closeDialog();
          },
          (error) => {
            console.log("error " + error);
          }
        );

      }
    },
    closeDialog() {

      this.formMode = "";
      this.$refs.refDeleteConfirmDialog.setDialogState(false);
      this.$refs.refFormDialog.setDialogState(false);

      this.$nextTick(() => {
        this.itemSelected = Object.assign({}, new FDinCarousel());
        this.itemSelectedIndex = -1;
      });
    },

    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },

    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id === fdivisionBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },

    lookupFDinCarouselType(finfratructureTypeBean) {
      const str = this.itemsFDinCarouselType.filter(
        (x) => x.id === finfratructureTypeBean
      );
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },

    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    } else {
      this.fetchParent();
      this.fetchFDinCarousel();
    }
  },
};
</script>

<style scoped>
</style>